<template>
  <div class="relative">
    <input
        :id="inputId"
        :type="type"
        class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent peer placeholder-transparent"
        :placeholder="label"
        v-model="inputValue"
        :min="min"
        :max="max"
        :step="step"
        @focus="handleFocus"
        @blur="handleBlur"
        @input="handleInput"
        @change="handleChange"
    />

    <label
        :for="inputId"
        class="absolute left-4 transition-all duration-200 ease-in-out pointer-events-none"
        :class="labelClasses"
    >
      {{ label }}
    </label>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  label: {
    type: String,
    default: 'Input *',
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
  inputId: {
    type: String,
    default: 'floating-input',
  },
  min: {
    type: [String, Number],
    default: '',
  },
  max: {
    type: [String, Number],
    default: '',
  },
  step: {
    type: [String, Number],
    default: '',
  },
})

const emit = defineEmits([
  'update:modelValue',
  'blur',
  'focus',
  'input',
  'change',
])

const isFocused = ref(false)

const inputValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const handleFocus = (e) => {
  isFocused.value = true
  emit('focus', e)
}

const handleBlur = (e) => {
  isFocused.value = false
  emit('blur', e)
}

const handleInput = (e) => {
  emit('input', e)
}

const handleChange = (e) => {
  emit('change', e)
}

const labelClasses = computed(() => {
  const hasContent =
      inputValue.value !== null &&
      inputValue.value !== undefined &&
      String(inputValue.value).trim() !== ''

  const shouldFloat = isFocused.value || hasContent

  return {
    'top-3 text-gray-500 text-base': !shouldFloat,
    '-top-2 text-primary text-xs bg-white px-1': shouldFloat,
  }
})
</script>
